import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { FetchData } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';

const moment = require('moment');

export class PostChecksForm extends Component {
  static displayName = PostChecksForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      model: props.model,
      alert: this.props.alert,
      deltaPosition: { x: 0, y: 0 },
    };

    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  onSave() {
    let model = this.state.model;
    model.ActionCode = 'AR';

    if (
      this.state.model.CheckDate === null ||
      this.state.model.CheckDate === ''
    ) {
      this.handleSaveEventSuccess({
        message: 'Please choose Check Date.',
        modal: true,
        color: 'warning',
      });
    } else {
      if (model.EventType === 'insert') {
        model.CreateByUserId = this.user.userid;
      } else if (model.EventType === 'update') {
        model.UpdateByUserId = this.user.userid;
      }

      FetchData('/savejobreceivable', 'POST', this.user.token, model).then(
        (data) => {
          if (data === 'Success') {
            this.props.handleSaveEventSuccess({
              message: data,
              modal: data === 'Success' ? false : true,
              color: data === 'Success' ? 'success' : 'warning',
            });
          } else {
            this.handleSaveEventSuccess({
              message: data,
              modal: data === 'Success' ? false : true,
              color: data === 'Success' ? 'success' : 'warning',
            });
          }
        }
      );
    }
  }

  handleChange(e) {
    let model = { ...this.state.model };

    if (e.target.type === 'number')
      model[e.target.name] = parseFloat(e.target.value);
    else if (e.target.type === 'checkbox')
      model[e.target.name] = e.target.checked;
    else model[e.target.name] = e.target.value;

    this.setState({ model });
  }

  keydownHandler(e) {
    if (e.keyCode === 83 && e.altKey) {
      this.onSave();
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;

    return (
      <Draggable
        handle=".post-checks-form-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: '700px',
            }}
            backdrop="static"
          >
            <ModalHeader className="post-checks-form-handle handle">
              Post Checks
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col style={{ textAlign: 'center' }}>
                    <Alert
                      color={this.state.alert.color}
                      isOpen={this.state.alert.isOpen}
                    >
                      {this.state.alert.message}
                    </Alert>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-8">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '90px' }}>
                        Job #:
                      </InputGroupText>
                      <input
                        type="text"
                        name="JobNum"
                        className="form-control form-control-text"
                        value={this.state.model.JobNum}
                        onChange={this.handleChange}
                        readOnly
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-8">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '90px' }}>
                        Job Date:
                      </InputGroupText>
                      <input
                        type="text"
                        name="JobDateTime"
                        className="form-control form-control-text"
                        value={moment(this.state.model.JobDateTime).format(
                          'MM/DD/YYYY'
                        )}
                        onChange={this.handleChange}
                        readOnly
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-8">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '90px' }}>
                        Check Date:
                      </InputGroupText>
                      <input
                        type="date"
                        name="CheckDate"
                        max={'9999-12-31'}
                        className="form-control form-control-text"
                        value={this.state.model.CheckDate}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-8">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '90px' }}>
                        Check Number:
                      </InputGroupText>
                      <input
                        type="text"
                        name="CheckNumber"
                        className="form-control form-control-text"
                        value={this.state.model.CheckNumber}
                        onChange={this.handleChange}
                        maxLength={25}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-8">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '90px' }}>
                        Amount:
                      </InputGroupText>
                      <input
                        type="number"
                        name="Amount"
                        className="form-control form-control-text"
                        value={
                          this.state.model.JobNum === 1 ||
                          this.state.model.JobNum === '1'
                            ? null
                            : this.state.model.Amount
                        }
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-8">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '90px' }}>
                        Is Refund:
                      </InputGroupText>
                      <input
                        type="checkbox"
                        name="IsRefund"
                        defaultChecked={this.state.model.IsRefund}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                {/* Additional sections commented out */}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="dark" onClick={this.props.setModal} size="sm">
                Cancel
              </Button>
              {/*<Button color="primary" onClick={() => { if (window.confirm("Are you sure to save this record?")) { this.onSave() } }} size="sm">Save</Button>*/}
              <Button color="primary" onClick={this.onSave} size="sm">
                Save
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </Draggable>
    );
  }
}
